// Storybook for React Native does not work on web (regression)
// https://github.com/storybookjs/react-native/issues/120
export default null
